import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IStateAssessment } from 'features/RiskManagement/Assessments'

export interface ISnackbar {
  id: string
  savedStateName: string
  currentAssessment: IStateAssessment | undefined
}

const initialState: ISnackbar = {
  id: '',
  savedStateName: '',
  currentAssessment: undefined
}

const snackbarSlice = createSlice({
  name: 'snackbars',
  initialState,
  reducers: {
    openNewSavedStatesDontMatchSystemScopeRoutesSnackbar(
      state,
      action: PayloadAction<ISnackbar>
    ) {
      return {
        ...state,
        id: action.type,
        savedStateName: action.payload.savedStateName,
        currentAssessment: action.payload.currentAssessment
      }
    },
    openNewAssessmentCompletedSnackbar(
      state,
      action: PayloadAction<ISnackbar>
    ) {
      return {
        ...state,
        id: action.type,
        savedStateName: action.payload.savedStateName,
        currentAssessment: action.payload.currentAssessment
      }
    },
    closeSnackbar() {
      return initialState
    }
  }
})

export default snackbarSlice.reducer

export const {
  openNewAssessmentCompletedSnackbar,
  openNewSavedStatesDontMatchSystemScopeRoutesSnackbar,
  closeSnackbar
} = snackbarSlice.actions
